import React from 'react';
import {
	useIsFeatureEnabled,
	RegisteredApplications,
	selectApplicationName,
	Page,
	InnovyzeRole,
	useIsAdmin,
} from '@innovyze/stylovyze';
import Admin from '@Pages/Admin';
import { useTabs } from '@Pages/Admin/tabs';
import { FLAGS } from '@Types/flags';
import { useSelector } from 'react-redux';
import { routes } from '.';
import { rootRoutes, sensorGroupRoutes, sensorOnly } from './routes';
import { useIntegrationPages } from '@Pages/index';
const {
	main,
	mainReadOnly,
	entitlements,
	uploadSensorDataRoutes,
	sensorAndSystemConfigs,
	manageSubscriptionUsers,
	editSensorData,
	valuemappingRoutes,
	liftStationsRoutes,
} = routes;

export default function useRoutes() {
	const applicationName = useSelector(selectApplicationName);
	const tabs = useTabs({});

	const integrationPages = useIntegrationPages();
	const isSensorDataEnabled = useIsFeatureEnabled(
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-ignore
		FLAGS.EDIT_SENSORS_DATA,
	);
	const isAdmin = useIsAdmin();
	const isUserAdminReadonly = !!useIsFeatureEnabled(
		FLAGS.USER_READONLY_ADMIN,
	);

	const isUserNonAdmin = isUserAdminReadonly && !isAdmin;

	const tabsPages = tabs.map((tab, index) => {
		return {
			title: tab.title,
			to: tab?.to ?? '',
			render: <Admin page={index} />,
			icon: tab?.icon,
			minimumRole: tab?.minimumRole ?? InnovyzeRole.ADMIN,
		};
	});

	const pages: Page[] = [];

	if (!isUserNonAdmin) {
		pages.push(
			...main,
			...entitlements,
			...uploadSensorDataRoutes,
			...sensorAndSystemConfigs,
			...tabsPages,
		);
		if (applicationName === RegisteredApplications.APP_ADMIN) {
			pages.push(...rootRoutes);
		}

		pages.push(...manageSubscriptionUsers);
	} else {
		pages.push(...mainReadOnly, ...sensorOnly, ...tabsPages);

		if (applicationName === RegisteredApplications.APP_ADMIN) {
			pages.push(...rootRoutes);
		}
	}
	if (isSensorDataEnabled) pages.push(...editSensorData);

	pages.push(...valuemappingRoutes);
	pages.push(...sensorGroupRoutes);
	pages.push(...liftStationsRoutes);

	pages.push(...integrationPages);

	return pages;
}
